<template>
  <helper-layout :loaded="mx_loaded">
    <v-form
      ref="fileForm"
      @submit.native.prevent
    >
      <v-layout column>
        <v-flex>
          <v-card
            v-show="!showThirdStep"
            class="mt-20"
          >
            <v-layout column>
              <v-flex>
                <div class="card-title">
                  1.{{ $t("Views.Customer.uploadFile") }}
                </div>
              </v-flex>
              <v-flex>
                <!-- 导入规则说明： -->
                <p class="tips">
                  {{ $t("Views.Customer.importRuleDesc") }}
                </p>
                <p class="tips">
                  {{ $t('Views.Order.supportRule') }}
                </p>
              </v-flex>
              <v-flex>
                <input
                  id="uploadButton"
                  type="file"
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style="display: none;"
                  @change="onSelectExcel"
                >
                <v-btn
                  color="success"
                  style="margin:10px 0 10px 30px;"
                  @click="onUploadClick"
                >
                  {{ $t("Views.Customer.uploadClick") }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>

          <v-layout v-show="showThirdStep" column>
            <v-card>
              <v-layout column>
                <v-flex>
                  <div class="card-title">
                    2.{{ $t("Views.Customer.sureImport") }}
                  </div>
                </v-flex>
                <v-flex>
                  <p style="color:#4CAF50 " class="tips">
                    {{ total }}
                  </p>
                </v-flex>
                <v-flex v-show="validateExcelData&&validateExcelData.invalidedRows > 0">
                  <material-table
                    class="fix-table"
                    :headers="headers"
                    :items="showItems"
                    :total-count="showItems.totalCount"
                    :paginate="paginateConfig"
                    @pageChange="handlePageChange"
                  />
                </v-flex>

              </v-layout>
            </v-card>
            <v-flex style="text-align:center;margin-top:20px;">
              <v-spacer />
              <v-btn @click="onPreviousStep">
                {{ $t("Views.Customer.lastStep") }}
              </v-btn>
              <v-btn
                v-if="validateExcelData.validatedRows!==0"
                color="success"
                @click="onSubmitClick"
              >
                {{ $t("Views.Customer.importSure") }}
              </v-btn>
              <v-spacer />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- 正在加载数据loading -->
        <div v-if="showLoading" class="showLoading-wrap">
          <v-layout
            column
            style="background-color:#5cb860"
          >
            <v-flex>
              <h3 style="text-align:center;color:white;padding:10px;">
                {{ tip }}
              </h3>
            </v-flex>
            <v-flex style="margin:0 10px 0 10px;">
              <v-progress-linear
                :value="progress"
                :indeterminate="showLoading"
                color="white"
                height="10"
              />
            </v-flex>
          </v-layout>
        </div>
      </v-layout>
    </v-form>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      headers: [
        {
          text: $t('Views.Customer.lines'),
          value: 'rowIndexStr',
          sortable: false
        },
        {
          text: $t('Views.Customer.resonErr'),
          value: 'errorMessage',
          sortable: true
        }
      ],
      showItems: [],
      progress: 0,
      showLoading: false,
      isValidate: true,
      file: null,
      items: [],
      showThirdStep: false
    }
  },
  computed: {
    ...mapState('order', ['validateExcelData']),

    total() {
      return (
        this.$t('Views.Customer.errorTips', {
          '0': `${this.validateExcelData && this.validateExcelData.templateRows}`,
          '1': `${this.validateExcelData && this.validateExcelData.validatedRows}`,
          '2': `${this.validateExcelData && this.validateExcelData.invalidedRows}`
        })
      )
    },
    tip() {
      return this.isValidate
        ? this.$t('Views.Customer.validating')
        : this.$t('Views.Customer.uploading')
    }
  },
  mounted() {
    this.mx_loaded_fn()
  },
  methods: {
    ...mapActions('order', ['handleValidateExcel', 'handleImportExcel']),
    /** 点击了上传文件 */
    onUploadClick() {
      if (this.$refs.fileForm.validate()) {
        const input = document.getElementById('uploadButton')
        if (input != null) {
          input.click()
        }
      }
      this.paginateConfig.page = 1
    },
    /** 选择excel并校验正确性 */
    onSelectExcel(value) {
      const _this = this
      this.isValidate = true
      const size = value.target.files[0].size
      if (size) {
        if (size >= 10 * 1024 * 1024) {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Customer.noFileBiggerThan'),
            type: 'error'
          })
          value.target.value = ''
          return
        }
      } else {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Customer.noFileBiggerThan'),
          type: 'error'
        })
        value.target.value = ''
        return
      }

      this.file = value.target.files[0]
      if (!this.file) {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Customer.fileERR'),
          type: 'error'
        })
        value.target.value = ''
        return
      }

      /** 判断文件类型 */
      const types = '.xls,.xlsx'.split(',')
      const name = this.file.name
      const type = name.substring(name.lastIndexOf('.'))

      if (types.indexOf(type) === -1) {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Customer.properFileNeeded'),
          type: 'error'
        })
        value.target.value = ''
        return
      }

      var formData = new FormData()
      formData.append('file', this.file)

      const config = {
        // 添加请求头
        headers: { 'Content-Type': 'multipart/form-data' },
        // 添加上传进度监听事件
        onUploadProgress: function(e) {
          _this.progress = (e.loaded / e.total) * 100
        }
      }

      this.showLoading = true
      this.handleValidateExcel({
        formData: formData,
        progess: config.onUploadProgress
      }).then(res => {
        if (res.success === true) {
          if (Object.keys(res).length > 1) {
            _this.paginateConfig.total = this.validateExcelData.invalidedMessages.length
            _this.showThirdStep = true
            _this.showItems = _this.getItemsByPage()
          } else {
            // this.$store.commit('app/setNotification', {
            //   msg: this.$t('Views.Customer.upload_fail_label'),
            //   type: 'error'
            // });
          }
          _this.showLoading = false
          value.target.value = ''
        } else {
          // this.$store.commit('app/setNotification', {
          //   msg: this.$t('Views.Customer.upload_fail_label'),
          //   type: 'error'
          // });
          this.showThirdStep = false
          this.showLoading = false
          this.file = null
          value.target.value = ''
        }
      })
    },
    /** 确认上传 */
    onConfirmUpload() {
      if (!this.$refs.fileForm.validate()) {
        return
      }
      this.progress = 0
      this.isValidate = false
      const _this = this
      var formData = new FormData()
      formData.append('file', this.file)
      const config = {
        // 添加请求头
        headers: { 'Content-Type': 'multipart/form-data' },
        // 添加上传进度监听事件
        onUploadProgress: function(e) {
          _this.progress = (e.loaded / e.total) * 100
        }
      }

      this.showLoading = true

      this.handleImportExcel({
        formData: formData,
        progess: config.onUploadProgress
      }).then(res => {
        if (res.success === true) {
          this.$store.commit('app/setNotification', {
            msg:
              this.$t('Views.Customer.successImport', { '0': `${res.count}` }),
            type: 'success'
          })
          this.file = null
          _this.showThirdStep = false
          _this.showLoading = false
          _this.$router.back()
        } else {
          if (res) {
            if (res.error) {
              this.$store.commit('app/setNotification', {
                msg: res.error.message,
                type: 'error'
              })
            } else {
              this.$store.commit('app/setNotification', {
                msg: res.result.title,
                type: 'error'
              })
            }
          }
          _this.showThirdStep = false
          _this.showLoading = false
        }
      }).catch(() => {
        _this.showLoading = false
      })
    },
    /** 点击了上一步 */
    onPreviousStep() {
      this.showThirdStep = false
    },
    /** 点击确认导入 */
    onSubmitClick() {
      if (this.file) {
        this.onConfirmUpload()
      }
    },
    handlePageChange(page) {
      this.paginateConfig.page = page
      this.showItems = this.getItemsByPage()
    },
    getItemsByPage() {
      const page = this.paginateConfig.page
      const pageSize = this.paginateConfig.pageSize
      if (this.validateExcelData.invalidedMessages.length > 0) {
        return this.validateExcelData.invalidedMessages.slice((page - 1) * pageSize, page * pageSize)
      } else {
        return []
      }
    }
  }
}
</script>

<style scoped>
.search-area {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  border-top: 10px solid #5cb85f;
}
.card-title {
  font-weight: bold;
  font-size: 18px;
  color: #4caf50;
  letter-spacing: 0;
  margin: 26px 0 34px 30px;
}
.mt-20 {
  margin-top: 20px;
}
.fix-table{
  margin: 0 10px 0 10px;
}
.tips{
  margin:10px 10px 10px 30px;
}
</style>
